// src/pages/auth/LoginPage.tsx (your snippet)
import { GalleryVerticalEnd } from 'lucide-react';
import homeImage from '@/assets/home.svg';
import ModeToggle from '@/components/mode-toggle';
import LoginScreen from './LoginScreen';

const LoginPage = () => {
  return (
    <div className="grid min-h-svh lg:grid-cols-2">
      <div className="flex flex-col gap-4 p-6 md:p-10">
        <div className="flex justify-center gap-2 md:justify-between">
          <a href="#" className="flex items-center gap-2 font-medium">
            <div className="bg-primary text-primary-foreground flex size-6 items-center justify-center rounded-md">
              <GalleryVerticalEnd className="size-4" />
            </div>
            HomeVein
          </a>
          <ModeToggle />
        </div>

        <div className="flex flex-1 items-center justify-center">
          <div className="w-full max-w-xs">
            <LoginScreen /> {/* container renders <LoginForm .../> */}
          </div>
        </div>
      </div>

      <div className="bg-muted relative hidden lg:block">
        <img
          src={homeImage}
          alt="Image"
          className="absolute inset-0 h-full w-full object-contain dark:brightness-[0.2] dark:grayscale"
        />
      </div>
    </div>
  );
};
export default LoginPage;
